import { types, Instance } from 'mobx-state-tree';
const { model, string, array, identifier, maybe, maybeNull, number } = types;

export const LDAPGroupModel = model('LDAPGroupModel', {
  base: string,
  dn: identifier,
  cn: string,
  description: maybe(string),
  gidnumber: maybe(string),
  group_id: maybeNull(number),
  gosagroupobjects: maybe(string),
  member: maybe(array(string)),
  memberuid: array(string),
  objectсlass: array(string),
  owner: maybe(string),
  createtimestamp: maybeNull(string),
  modifytimestamp: maybeNull(string),
  email: maybeNull(string),
  google_id: maybeNull(string),
  zoom_id: maybeNull(string),
  microsoft_id: maybeNull(string),
  reSyncProvider: array(string),
  end_date: maybeNull(string),
  managers: array(string),
  managersData: maybe(array(types.frozen())),
});

export type ILDAPGroupModel = Instance<typeof LDAPGroupModel>;

export const ManagerGroupModel = model('ManagerGroupModel', {
  base: string,
  dn: identifier,
  cn: string,
  description: maybe(string),
  gidnumber: maybe(string),
  gosagroupobjects: maybe(string),
  member: maybe(array(string)),
  memberuid: array(string),
  objectсlass: array(string),
  owner: maybe(string),
  createtimestamp: maybeNull(string),
  modifytimestamp: maybeNull(string),
  email: maybeNull(string),
  google_id: maybeNull(string),
  zoom_id: maybeNull(string),
  microsoft_id: maybeNull(string),
  reSyncProvider: array(string),
  end_date: maybeNull(string),
  managers: array(string),
  managersData: maybe(array(types.frozen())),
});

export type IManagerGroupModel = Instance<typeof ManagerGroupModel>;

/*
{
  "objectclass": [
      "groupOfNames",
      "gosaGroupOfNames",
      "hostObject"
  ],
  "dn": "cn=group_2,ou=department4newnew,ou=department3,ou=department2,ou=department1,dc=company2,dc=webuserid,dc=com",
  "base": "/department4newnew/department3/department2/department1",
  "cn": "group_2",
  "description": "System Administrator OO2",
  "gosagroupobjects": "[U]",
  "owner": "uid=johndoe,ou=people,dc=company2,dc=webuserid,dc=com",
  "member": [
      "uid=xtz,ou=people,ou=department4,ou=department3,ou=department2,ou=department1,dc=company2,dc=webuserid,dc=com",
      "uid=ttt2,ou=people,ou=department4,ou=department3,ou=department2,ou=department1,dc=company2,dc=webuserid,dc=com"
  ]
}
*/
